import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import EmptyState from 'garaje/components/empty-state';

interface QuestionnairesEmptyStateSignature {
  Args: {
    canCreateQuestionnaires: boolean;
    createRoute: string;
    /**
     * If true, indicates that this empty state is because nothing matches filters. (A value of false, or omitting
     * this argument) indicates that this empty state is because there are no questionnaires at all.
     */
    isFiltered?: boolean;
  };
}

export default class QuestionnairesEmptyState extends Component<QuestionnairesEmptyStateSignature> {
  get description(): string {
    if (this.args.isFiltered) {
      return 'Try changing your filters.';
    }
    return 'Show media to visitors and perform a knowledge check with multiple choice questions.';
  }

  get title(): string {
    if (this.args.isFiltered) {
      return 'No assessments match your filters';
    }
    return 'Get started creating assessments for visitors';
  }

  <template>
    <EmptyState @description={{this.description}} @imgClass="questionnaires-empty-state-img" @title={{this.title}}>
      <div class="flex gap-4">
        {{#if @canCreateQuestionnaires}}
          <LinkTo @route={{@createRoute}} class="btn btn--brand">Create a new assessment</LinkTo>
        {{/if}}
        <a
          href="http://envoy.help/en/articles/11840176-assessments"
          class="btn btn--outline"
          target="_blank"
          rel="noopener"
        >
          Learn more
        </a>
      </div>
    </EmptyState>
  </template>
}
